export const SET_ORACLE_PERSONA = 'SET_ORACLE_PERSONA'
export const SET_ORACLE_ACCESS_PROCESSING = 'SET_ORACLE_ACCESS_PROCESSING'
export const SET_ORACLE_ACCESS = 'SET_ORACLE_ACCESS'
export const SET_ORACLE_ACCESS_ERROR = 'SET_ORACLE_ACCESS_ERROR'
export const SET_ORACLE_GUIDE_ON_SIDE_CLOSED = 'SET_ORACLE_GUIDE_ON_SIDE_CLOSED'
export const SET_ORACLE_GUIDE_ENABLED = 'SET_ORACLE_GUIDE_ENABLED'
export const SET_ORACLE_GUIDE_TOAST_DISMISSED = 'SET_ORACLE_GUIDE_TOAST_DISMISSED'

export function setOraclePersona (persona) {
  return {
    type: SET_ORACLE_PERSONA,
    payload: { persona },
  }
}

export function setOracleAccessProcessing (processing) {
  return {
    type: SET_ORACLE_ACCESS_PROCESSING,
    payload: { processing },
  }
}

export function setOracleAccess (access, processing = false) {
  return {
    type: SET_ORACLE_ACCESS,
    payload: { access, processing },
  }
}

export function setOracleAccessError (error) {
  return {
    type: SET_ORACLE_ACCESS_ERROR,
    payload: { error },
  }
}

/**
 * Set whether the Oracle Guide on Side is closed
 * @param {boolean} closed - true = closed, false = open
 */
export function setOracleGuideOnSideClosed (closed) {
  return {
    type: SET_ORACLE_GUIDE_ON_SIDE_CLOSED,
    payload: { closed },
  }
}

/**
 * Set whether the Oracle Guide is enabled for this user.
 * This is determined by both Gaia config flag and PostHog experiment flags.
 * @param {boolean} enabled - true = user is eligible to see the guide
 */
export function setOracleGuideEnabled (enabled) {
  return {
    type: SET_ORACLE_GUIDE_ENABLED,
    payload: { enabled },
  }
}

/**
 * Set the toast nudge as dismissed for a given video (by contentId).
 * Prevents the toast from re-appearing for the same video.
 * @param {string} contentId - the contentId of the video
 */
export function setOracleGuideToastDismissed (contentId) {
  return {
    type: SET_ORACLE_GUIDE_TOAST_DISMISSED,
    payload: { contentId },
  }
}

// TODO: Future - pin/unpin functionality (commented for v1)
// export const SET_ORACLE_GUIDE_ON_SIDE_STATE = 'SET_ORACLE_GUIDE_ON_SIDE_STATE'
// /**
//  * Set the Oracle Guide on Side state
//  * @param {string} state - One of: 'closed', 'unpinned', 'pinned'
//  */
// export function setOracleGuideOnSideState (state) {
//   return {
//     type: SET_ORACLE_GUIDE_ON_SIDE_STATE,
//     payload: { state },
//   }
// }
